import { render, staticRenderFns } from "./ConfigTabs.vue?vue&type=template&id=fd31edac"
import script from "./ConfigTabs.vue?vue&type=script&lang=js"
export * from "./ConfigTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports